import classNames from 'classnames';
import { memo } from 'react';
import { useT } from '../../../translation/src';

const Property_: React.FC2<{ title: React.ReactNode }> = ({ title, children, className }) => {
  return (
    <div className={classNames('flex items-center text-sm', className)}>
      <div className="flex-shrink-0 w-32 text-[#6F7173] dark:text-[#C2C6C8]">{title}</div>
      <div className="flex flex-grow">{children}</div>
    </div>
  );
};
export const Property = memo(Property_);

interface PropertiesSectionProps {
  title?: React.ReactNode;
  hasToggle?: boolean;
  toggleEnabled?: boolean;
  onToggle?: () => void;
  toggleTitle?: React.ReactNode;
  /** Optional control rendered on the right of the title (e.g. a filter button) */
  headerAction?: React.ReactNode;
}
const PropertiesSection_: React.FC2<PropertiesSectionProps> = ({ title, children, className, hasToggle = false, toggleEnabled = true, onToggle, toggleTitle, headerAction }) => {
  const defaultToggleTitle = useT('toggle', { swc: true });
  const translatedToggleTitle = useT(typeof toggleTitle === 'string' ? toggleTitle : '', { swc: true });
  const resolvedToggleTitle = translatedToggleTitle || toggleTitle || defaultToggleTitle;
  return (
    <div className={classNames('flex flex-col w-full text-sm relative', className)}>
      {(title || headerAction) && (
        <div className="mb-4 font-bold dark:text-white flex justify-between items-center">
          <span>{title}</span>
          {hasToggle && onToggle && (
            <input
              type="checkbox"
              checked={toggleEnabled}
              onChange={onToggle}
              className="w-4 h-4 rounded cursor-pointer mr-2 border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 checked:bg-neon-green-700 checked:border-neon-green-700 focus:ring-2 focus:ring-neon-green-500 dark:focus:ring-neon-green-600 dark:ring-offset-gray-800"
              title={typeof resolvedToggleTitle === 'string' ? resolvedToggleTitle : defaultToggleTitle}
            />
          )}
          {headerAction}
        </div>
      )}
      <div
        className={classNames('flex flex-col w-full space-y-2 pb-4', {
          'opacity-50': hasToggle && !toggleEnabled,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export const PropertiesSection = memo(PropertiesSection_);
